// this is an autogenerated file from App/Account/NewPatient/Content/mutation-add-patient-to-lead.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_NewPatient_Content($lead_id: uuid!, $patient_id: uuid!) {
  update_leads_leads_by_pk(
    pk_columns: { id: $lead_id }
    _set: { patient_id: $patient_id }
  ) {
    id
  }
}

`